import type * as React from 'react';

/**
 Generated using: https://react-svgr.com/playground

 How to import new SVGs:
 1. open the SVG in a text editor
 2. copy the <svg ...>  </svg> portion and replace the same section in this file, keeping the {...props}
 3. remove xmlns:xlink attribute from root svg element
 4. replace all xlink:href attributes with href
 5. replace all `fontFamily="Roboto-????, Roboto"` with matching `fontFamily="Roboto-????, Roboto, Helvetica Neue, HelveticaNeue, Helvetica, Arial, sans-serif"`
*/

const SaveMoney = () => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 129 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M90.3093 43.0412L78.0197 25.4944C74.8182 20.9233 68.7976 19.3101 63.7393 21.668L44.3228 30.7191C41.2412 32.1556 38.9528 34.8826 38.0728 38.1668L25.0157 86.8963C23.3717 93.032 27.0129 99.3387 33.1486 100.983L64.8546 109.478C70.9904 111.122 77.2971 107.481 78.9411 101.346L91.9981 52.616C92.8781 49.3319 92.2601 45.8261 90.3093 43.0412Z"
      fill="#6E56E6"
    />
    <path
      d="M98.1647 37.9196L81.3342 23.8006C76.9498 20.1224 70.5579 20.1224 66.1732 23.8006L49.3427 37.9196C46.6714 40.1604 45.1284 43.469 45.1284 46.9557V98.69C45.1284 105.204 50.4091 110.485 56.9231 110.485H90.5843C97.0984 110.485 102.379 105.204 102.379 98.69V46.9557C102.379 43.469 100.836 40.1604 98.1647 37.9196ZM73.7537 43.6523C70.4343 43.6523 67.7433 40.9609 67.7433 37.6417C67.7433 34.3221 70.4343 31.6311 73.7537 31.6311C77.0734 31.6311 79.7643 34.3221 79.7643 37.6417C79.7643 40.9609 77.0734 43.6523 73.7537 43.6523Z"
      fill="#EE399E"
    />
    <path
      d="M71.792 69.0547H75.7154C76.7488 69.1659 77.5658 69.983 77.677 71.0163C77.5518 72.0436 76.7426 72.8528 75.7154 72.978H69.8304C68.7471 72.978 67.8687 73.8564 67.8687 74.9397C67.8687 76.023 68.7471 76.9014 69.8304 76.9014H71.792V78.863C71.792 79.9463 72.6704 80.8247 73.7537 80.8247C74.837 80.8247 75.7154 79.9463 75.7154 78.863V76.9014C77.8181 76.9014 79.7604 75.7795 80.8121 73.9589C81.863 72.1382 81.863 69.8945 80.8121 68.0738C79.7605 66.2532 77.818 65.1314 75.7154 65.1314H71.792C70.7088 65.1314 69.8304 64.253 69.8304 63.1697C69.8304 62.0864 70.7088 61.208 71.792 61.208H77.677C78.7603 61.208 79.6387 60.3296 79.6387 59.2463C79.6387 58.1631 78.7603 57.2847 77.677 57.2847H75.7154V55.323C75.7154 54.2397 74.837 53.3613 73.7537 53.3613C72.6704 53.3613 71.792 54.2397 71.792 55.323V57.2847C69.6894 57.2847 67.747 58.4065 66.6953 60.2272C65.6444 62.0478 65.6444 64.2915 66.6953 66.1122C67.747 67.9328 69.6894 69.0547 71.792 69.0547Z"
      fill="white"
    />
    <path
      d="M73.7539 35.5518C72.2578 35.5518 71.0449 34.3389 71.0449 32.8428V14.0977C71.0449 12.6016 72.2578 11.3887 73.7539 11.3887C75.25 11.3887 76.4629 12.6016 76.4629 14.0977V32.8428C76.4629 34.3389 75.25 35.5518 73.7539 35.5518Z"
      fill="#FDD651"
    />
    <path
      d="M92.1577 88.7129H57.1558V91.6787H92.1577V88.7129Z"
      fill="#F470BD"
    />
    <path
      d="M88.9614 96.9219H60.3521V99.8877H88.9614V96.9219Z"
      fill="#F470BD"
    />
  </svg>
);

export { SaveMoney };
